module.exports = __webpack_public_path__ + "01795419bc5c37d47416f595f17bfd.png";